import React, {useState} from 'react';

// Aws Data Store and Model
import { DataStore } from 'aws-amplify';
import { Form } from '../models';

// React Router
import { useNavigate, useParams } from 'react-router';

import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';

// Create a New Color function
function onCreate() {
    DataStore.save(
        new Form ({
            name:"",
        })
    );
}

export default function FormsForm() {

    const [ form, setForm ] = React.useState('');
    const {id} = useParams();
    const [fadeIn, setFadeIn] = useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        fetchForm();
        async function fetchForm() {
            const form = await DataStore.query(Form);
            setForm(form)
        }
    }, [id]);

    const [name, setName] = useState('');

    async function saveForm() {
        const tempForm = new Form({
            name:name,
        });
        await DataStore.save(tempForm);
    }

    function handleChange(event) {
        console.log(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        saveForm().then((data) => {
            setFadeIn(true);
            setTimeout(() => {
                navigate('/', {replace: true});
            }, 1500);
        });
    }

    return (
        <form>
            <Box>
            <FormControl variant="standard" style={{width:'100%'}}>
                <InputLabel htmlFor="component-simple" style={{color:'#E30015'}}>Name</InputLabel>
                <Input
                    style={{borderBottom:'2px solid white', width:'100%'}}
                    id="name"
                    name="name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                />
            </FormControl>
            </Box>
            <Box style={{marginTop:'20px'}}>
                <Button 
                    onClick={handleSubmit}
                    style={{backgroundColor:'#E30015', color:'white', fontWeight:'700'}}
                >
                    Speichern
                </Button>
            </Box>
        </form>
    )
}
